import axios from "axios";
import {ordersServicesPath} from "../../../../Constants";

const materialEstimateUnitUrl = ordersServicesPath + '/customers/material-estimate-units'

export default class CustomerMaterialEstimateUnitService {

    static async getAllByOrderId(orderId) {
        return axios.get(materialEstimateUnitUrl + '/by-order-id?orderId=' + orderId);
    }

    static async getAllByEstimateOrganization(estimateId) {
        return axios.get(materialEstimateUnitUrl + '/by-estimate-id' + '?estimateId=' + estimateId);
    }
}